/*! AS Web Vitals v1.0 — first-party real-user monitoring. Captures TTFB, FCP, LCP, CLS, INP per page
 *  and pushes one `web_vitals` event per metric to window.dataLayer when the page is hidden,
 *  so GTM can forward to GA4 (event params: metric_name, metric_value, metric_rating,
 *  metric_id, page_type). Zero dependencies, ~1.5KB. Debug: window.ASVitals.snapshot() */
(function (w, d) {
  'use strict';
  if (w.ASVitals || !w.PerformanceObserver) return;
  var m = { TTFB: null, FCP: null, LCP: null, CLS: 0, INP: null }, sent = {};
  var id = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  var pageType = (d.body && (d.body.className.match(/template-(\w+)/) || [])[1]) || 'unknown';

  function obs(type, cb, opts) { try { new PerformanceObserver(function (l) { cb(l.getEntries()); }).observe(Object.assign({ type: type, buffered: true }, opts || {})); } catch (e) {} }

  var nav = performance.getEntriesByType('navigation')[0];
  if (nav) m.TTFB = nav.responseStart;
  obs('paint', function (es) { es.forEach(function (e) { if (e.name === 'first-contentful-paint') m.FCP = e.startTime; }); });
  obs('largest-contentful-paint', function (es) { if (es.length) m.LCP = es[es.length - 1].startTime; });

  // CLS with session windows (max 5s, 1s gap) per web.dev definition
  var sess = 0, sessStart = 0, sessLast = 0;
  obs('layout-shift', function (es) {
    es.forEach(function (e) {
      if (e.hadRecentInput) return;
      if (sess && e.startTime - sessLast < 1000 && e.startTime - sessStart < 5000) { sess += e.value; sessLast = e.startTime; }
      else { sess = e.value; sessStart = sessLast = e.startTime; }
      if (sess > m.CLS) m.CLS = sess;
    });
  });

  // INP: 98th percentile-ish of interaction durations
  var inter = [];
  obs('event', function (es) {
    es.forEach(function (e) { if (e.interactionId) inter.push(e.duration); });
    if (inter.length) { inter.sort(function (a, b) { return b - a; }); m.INP = inter[Math.min(inter.length - 1, Math.floor(inter.length / 50))]; }
  }, { durationThreshold: 40 });

  function rating(k, v) {
    var t = { TTFB: [800, 1800], FCP: [1800, 3000], LCP: [2500, 4000], CLS: [0.1, 0.25], INP: [200, 500] }[k];
    return v <= t[0] ? 'good' : v <= t[1] ? 'needs-improvement' : 'poor';
  }
  function flush() {
    w.dataLayer = w.dataLayer || [];
    Object.keys(m).forEach(function (k) {
      var v = m[k]; if (v === null || sent[k] === v) return; sent[k] = v;
      w.dataLayer.push({ event: 'web_vitals', metric_name: k, metric_value: k === 'CLS' ? +v.toFixed(4) : Math.round(v), metric_rating: rating(k, v), metric_id: id, page_type: pageType });
    });
  }
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') flush(); });
  w.addEventListener('pagehide', flush);

  w.ASVitals = { snapshot: function () { return JSON.parse(JSON.stringify(m)); }, flush: flush, pageType: pageType };
})(window, document);
